import React from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { useRouter } from 'next/router';

const HomeLayout = ({ children }) => {
  const router = useRouter();
  const isHome = router.pathname === '/';
  return (
    <>
      <Header isHome={isHome ? true : false} />
      <main className={`main ${isHome ? 'main-home' : ''}`}>{children}</main>
      <Footer />
    </>
  );
};

HomeLayout.propTypes = {
  children: PropTypes.any,
};

export default HomeLayout;
